import { queryCache } from 'react-query';
import { ParentPasswordChangeFormType, ParentPasswordSetFormType, PasswordChangeFormType, ProfileFormType } from '../components/Forms/form-types';
import { routesURLs } from '../Routes';
import api from '../services/api';
import { deleteCookie, getCookie, setCookie } from '../services/utils';

export const getProfile = () => {
    return api.get('/profile').then((res) => {
        if (!getCookie('analytics_user_id')) {
            setCookie('analytics_user_id', res.data.data.analytics_user_id, 400);
        }

        return res.data.data;
    });
};

export const updateProfile = (data: ProfileFormType) => {
    return api.put('/profile', data).then((res) => {
        return res.data.data;
    });
};

export const changePassword = (data: PasswordChangeFormType) => {
    return api.post('/password', data).then((res) => {
        return res.data.data;
    });
};

export const setParentPassword = (data: ParentPasswordSetFormType) => {
    return api.post('/set-parent-password', data).then(async (res) => {
        queryCache.setQueryData('profile', await getProfile(), {
            cacheTime: Infinity,
        });

        return res.data.data;
    });
};

export const changeParentPassword = (data: ParentPasswordChangeFormType) => {
    return api.post('/change-parent-password', data).then((res) => {
        return res.data.data;
    });
};

export const checkParentPassword = (parentPassword: string) => {
    return api.post('/check-parent-password', { parent_password: parentPassword });
};

export const deleteProfile = () => {
    return api.delete('/profile').then(async () => {
        deleteCookie('jid');
        deleteCookie('analytics_user_id');
        window.router.replace(routesURLs.homepage);
    });
};
